import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-dispatch-confirmation-dialog',
  templateUrl: './dispatch-confirmation-dialog.component.html',
  styleUrls: ['./dispatch-confirmation-dialog.component.scss']
})
export class DispatchConfirmationDialogComponent implements OnInit {

  constructor(readonly dialogRef: MatDialogRef<DispatchConfirmationDialogComponent>) { }

  ngOnInit(): void { }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    this.dialogRef.close(true);
  }
}
